import * as fromRoot from '../../reducers';
import * as ReportReducer from './reports.reducer';
import * as ReportNavigationReducer from './report-navigation.reducer';
import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

export interface ReportState {
  reports: ReportReducer.State;
  navigation: ReportNavigationReducer.State
}

export interface State extends fromRoot.State {
  reportState: ReportState;
}

export const reducers: ActionReducerMap<ReportState, Action> = {
  reports: ReportReducer.reducer,
  navigation: ReportNavigationReducer.reducer
};
export const selectReportState = createFeatureSelector<State, ReportState>('reportState');

export const selectReportsState = createSelector(selectReportState, (state: ReportState) => state.reports);
export const selectReportNavigationState = createSelector(selectReportState, (state: ReportState) => state.navigation);

export const getRecurringReports = createSelector(selectReportsState, ReportReducer.getRecurringReports);
export const getRecurringReportById = createSelector(selectReportsState, ReportReducer.getRecurringReportById);
export const getLastModifiedReport = createSelector(selectReportsState, ReportReducer.getLastModifiedReport);
export const getIsCreated = createSelector(selectReportsState, ReportReducer.getIsCreated);
export const getReportFileTypes = createSelector(selectReportsState, ReportReducer.getReportFileTypes);
export const getAllReportFileTypes = createSelector(selectReportsState, ReportReducer.getAllReportFileTypes);
export const hasError = createSelector(selectReportsState, ReportReducer.hasError);
export const getAreRecurringReportsLoaded = createSelector(selectReportsState, ReportReducer.getAreRecurringReportsLoaded);
export const getAreRecurringReportsLoading = createSelector(selectReportsState, ReportReducer.getAreRecurringReportsLoading);
export const getAreReportsHistoryLoading = createSelector(selectReportsState, ReportReducer.getAreReportsHistoryLoading);
export const getAreReportsHistoryLoaded = createSelector(selectReportsState, ReportReducer.getAreReportsHistoryLoaded);
export const getReportsHistory = createSelector(selectReportsState, ReportReducer.getReportsHistory);
export const getReportHistoryById = createSelector(selectReportsState, ReportReducer.getReportHistoryById);
export const selectCreatingState = createSelector(getIsCreated, hasError, (isCreated, error) => ({isCreated: isCreated, error: error }));

export const getSelectedTab = createSelector(selectReportNavigationState, ReportNavigationReducer.getSelectedTab);
export const getSelectedReport = createSelector(selectReportNavigationState, ReportNavigationReducer.getSelectedReport);
